(function() {
  'use strict';

  // --- 1. Handle Country / Currency Switching ---
  function handleCountrySwitch(countryCode) {
    if (!countryCode) return;

    try {
      localStorage.setItem('bvt_selected_country', countryCode);
    } catch (e) {}

    const formData = new FormData();
    formData.append('country_code', countryCode);
    formData.append('form_type', 'localization');
    formData.append('utf8', '✓');
    formData.append('_method', 'put');

    const url = new URL(window.location.href);
    url.searchParams.delete('section_id');
    const returnTo = url.pathname + (url.search ? url.search : '');
    formData.append('return_to', returnTo);

    document.body.style.cursor = 'wait';

    fetch('/localization', {
      method: 'POST',
      body: formData
    })
    .then(function() {
      window.location.href = returnTo;
    })
    .catch(function() {
      window.location.href = returnTo;
    });
  }

  // Intercept clicks on any country links in capture phase
  document.addEventListener('click', function(e) {
    const link = e.target && e.target.closest ? e.target.closest('a[data-value]') : null;
    if (!link) return;

    if (link.closest('#announcement_localization_country_form, #header_drawer_localization_country_form, .dropdown__nav, .modal__scrollable, [is="localization-listbox"], .localization')) {
      const code = link.getAttribute('data-value');
      if (code) {
        e.preventDefault();
        e.stopPropagation();
        handleCountrySwitch(code);
      }
    }
  }, true);

  // Intercept changes on footer select
  document.addEventListener('change', function(e) {
    if (e.target && (e.target.id === 'FooterLocalizationCountryList' || e.target.name === 'country_code')) {
      const code = e.target.value;
      if (code) {
        e.preventDefault();
        handleCountrySwitch(code);
      }
    }
  }, true);

  // --- 2. Live Storefront Currency Conversion Engine ---
  const cfg = window.BVT_CURRENCY;
  if (!cfg || !cfg.code || cfg.code === 'USD' || !cfg.rate || cfg.rate === 1) {
    return;
  }

  const rate = Number(cfg.rate) || 1;
  const code = cfg.code;
  const symbol = cfg.symbol || '';

  function formatConverted(usdCents) {
    const rawConverted = (usdCents / 100) * rate;
    const formattedNum = rawConverted.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    switch (code) {
      case 'EUR':
        return `€${formattedNum}`;
      case 'GBP':
        return `£${formattedNum}`;
      case 'CAD':
        return `CA$${formattedNum}`;
      case 'AUD':
        return `AU$${formattedNum}`;
      case 'NZD':
        return `NZ$${formattedNum}`;
      case 'SEK':
      case 'DKK':
        return `${formattedNum} kr`;
      case 'PLN':
        return `${formattedNum} zł`;
      case 'CZK':
        return `${formattedNum} Kč`;
      case 'HUF':
        return `${Math.round(rawConverted).toLocaleString('en-US')} Ft`;
      case 'RON':
        return `${formattedNum} lei`;
      case 'BGN':
        return `${formattedNum} лв`;
      default:
        return `${symbol}${formattedNum}`;
    }
  }

  function patchThemeCurrency() {
    if (window.theme && window.theme.Currency && !window.theme.Currency.__bvt_patched) {
      const origFormat = window.theme.Currency.formatMoney;
      window.theme.Currency.formatMoney = function(cents, format) {
        if (typeof cents === 'string') {
          cents = cents.replace('.', '');
        }
        const num = Number(cents);
        if (!isNaN(num)) {
          return formatConverted(num);
        }
        return origFormat(cents, format);
      };
      window.theme.Currency.__bvt_patched = true;
    }
  }

  const usdPriceRegex = /\$\s*(\d+(?:,\d{3})*(?:\.\d{2})?)/g;

  function convertTextNode(node) {
    if (!node.nodeValue || !node.nodeValue.includes('$')) return;
    const parent = node.parentElement;
    if (parent && parent.closest('script, style, textarea, input, code, pre')) return;

    const replaced = node.nodeValue.replace(usdPriceRegex, function(match, numStr) {
      const cleanNum = parseFloat(numStr.replace(/,/g, ''));
      if (isNaN(cleanNum)) return match;
      return formatConverted(cleanNum * 100);
    });
    if (replaced !== node.nodeValue) {
      node.nodeValue = replaced;
    }
  }

  function scanElement(root) {
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    let n;
    while ((n = walker.nextNode())) {
      convertTextNode(n);
    }
  }

  function init() {
    patchThemeCurrency();
    scanElement(document.body);

    const observer = new MutationObserver(function(mutations) {
      patchThemeCurrency();
      for (let i = 0; i < mutations.length; i++) {
        const m = mutations[i];
        if (m.type === 'childList') {
          for (let j = 0; j < m.addedNodes.length; j++) {
            const node = m.addedNodes[j];
            if (node.nodeType === 1) scanElement(node);
            else if (node.nodeType === 3) convertTextNode(node);
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
